<template>
  <div id="root">
    <keep-alive :include="['IndexPage']">
      <router-view class="router-view"></router-view>
    </keep-alive>
  </div>
</template>

<script>

/* eslint-disable */
// import translate from 'i18n-jsautotranslate'
export default {
  name: 'App',
  components: {
   
  },
  data() {
    return {
      
    }
  },
  created() {
    // window.translate = translate; //方便审核元素用控制台调试
    // translate.language.setLocal()
    // translate.setAutoDiscriminateLocalLanguage(); 
    // translate.service.use('client.edge'); //翻译通道
    // window.translate.whole.enableAll(); //整体翻译
    // this.$nextTick(() => {
    //   window.translate.execute();
    //   setTimeout(function () {
    //     //vue的input中的placeholder属性会在nextTick之后延迟渲染，而这个属性是没有别的方式来监听的，所以额外加一个定时器
    //     window.translate.execute();
    //   }, 500);
    //   window.translate.listener.start();    //开启html页面变化的监控
    // });
  },
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://plugin-code.salesmartly.com/js/project_262319_269181_1741141474.js';
    script.onload = () => {
      // 脚本加载完成后执行的代码
    };
    document.body.appendChild(script);

    
  
  },
  methods: {
   
  },
}
</script>

<style lang="scss">

#app {
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #F2F3F7;
}
.translateSelectLanguage{
    position: absolute;
    top:8px;
    right:20px;
    width: 160px;
    height: 20px;
    display: none;
    option{
      height: 30px;
      line-height: 30px;
      width: 160px;
    }
}
@media (max-width: 769px) {
  .translateSelectLanguage{
    width: 1.8667rem;
    font-size: 12px;
    position: absolute;
    top:.2133rem;
    right:.2667rem;
}
}

</style>
